'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            zoom: '=',
            zoomLevel: '=',
            map: '=',
            bounds: '='
        },
        template: [
            `<div class="trainSearch" tooltip="Search on: train id, official id, car id">
                  <div class="input-group">
                     <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-train"></i></span></span>
                     </div>
                    <input type="search" class="form-control" 
                           ng-model="markerId" ng-change="error=false" 
                           ng-class="{ \'marker-error\' : error }" ng-enter="clickMarker(markerId)">
                  </div>
             </div>`
            
        ].join(''),

        link: function (scope) {
            var zoom = false;
            var map;
            var zoomLevel = 13;
            scope.error = false;
            scope.resetMap = resetMap; 
            
            var resetMap = function() {
                map.fitBounds(scope.bounds);
            };

            scope.clickMarker = function (markerId) {
                if(!markerId) {
                    resetMap();
                    return;
                }
                if (util.isDefined(scope.markers)) {
                    var found = false;
                    scope.markers.forEach(function (marker) {
                        if ((marker.trainName == markerId || marker.trainId == markerId || marker.officialId == markerId) && util.isDefined(marker.map)) {
                            //new google.maps.event.trigger( marker, 'click' );
                            if (zoom && util.isDefined(map)) {
                                marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
                                map.setZoom(zoomLevel);
                                map.panTo(marker.position);
                            }
                            found = true;
                        } else {
                            marker.setZIndex(google.maps.Marker.MAX_ZINDEX);
                        }
                    });
                    if (!found) {
                        scope.error = true;
                    }
                }
            };
            scope.$watch('ngModel', function (modl) {
                scope.markers = modl;
            });

            scope.$watch('zoom', function (z) {
                if (util.isDefined(z)) {
                    zoom = z;
                }
            });

            scope.$watch('map', function (m) {
                if (util.isDefined(m)) {
                    map = m;
                }
            });

            scope.$watch('zoomLevel', function (zL) {
                if (util.isDefined(zL)) {
                    zoomLevel = zL;
                }
            });
        }
    };
};
